import { combineReducers } from 'redux';

import appReducer from './AppReducer';
import authReducer from './AuthReducer';
import taskReducer from './TaskReducer';
import rackReducer from './RackReducer';
import documentReducer from './DocumentReducer';

export default combineReducers({
    app: appReducer,
    authentication: authReducer,
    task: taskReducer,
    rack: rackReducer,
    document: documentReducer
});